import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a4caeb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_2 = {
  class: "flex flex-col",
  style: {"height":"1000px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl md:text-xl font-bold" }, " Allgemeine Informationen ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt-4 text-sm md:text-sm font-bold",
  style: {"border-style":"solid","border-color":"white white rgb(216,215,26)","border-radius":"5px"}
}, " Anmerkungen ", -1))
const _hoisted_5 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_6 = { class: "ml-2 text-xs" }
const _hoisted_7 = { class: "text-xs text-gray-500" }
const _hoisted_8 = { class: "text-xs md:text-xs ml-2" }
const _hoisted_9 = { class: "text-xs text-gray-500" }
const _hoisted_10 = {
  key: 1,
  class: "justify-center items-center col-span-5 mt-1",
  style: {"background-color":"rgb(235, 239, 240)","border-style":"solid","border-color":"rgb(235, 239, 240) rgb(235, 239, 240) rgb(235, 239, 240)\n          rgb(235, 239, 240)","border-radius":"5px"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-center" }, "Keine Anmerkungen aufgenommen", -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tng_header = _resolveComponent("tng-header")!
  const _component_UniversalPdfImageRow = _resolveComponent("UniversalPdfImageRow")!
  const _component_seilzugflaechen_footer = _resolveComponent("seilzugflaechen-footer")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAnmerkungenPages(_ctx.ba), (anmerkungPage, key) => {
    return (_openBlock(), _createBlock(_component_pdf_a4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang,
      class: "pdf-content",
      key: key
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_tng_header, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"]),
            _hoisted_3,
            _hoisted_4,
            (anmerkungPage['anmerkungen'].length >0 )
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(anmerkungPage['anmerkungen'], (anmerkung, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: key,
                      style: {"border-style":"solid","border-color":"white white white rgb(216, 215, 26)","border-radius":"5px"},
                      class: "mt-2"
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createTextVNode(" Titel: "),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(anmerkung.title) + ", " + _toDisplayString(anmerkung.lfndnr), 1)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createTextVNode(" Anmerkung: "),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(anmerkung.anmerkung), 1)
                      ]),
                      _createVNode(_component_UniversalPdfImageRow, {
                        "image-objects": anmerkung.bilder
                      }, null, 8, ["image-objects"])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
          ]),
          _createVNode(_component_seilzugflaechen_footer, {
            ba: _ctx.ba,
            immobilie: _ctx.immobilie,
            lang: _ctx.lang,
            class: ""
          }, null, 8, ["ba", "immobilie", "lang"])
        ])
      ]),
      _: 2
    }, 1032, ["pdf-key"]))
  }), 128))
}